import { roomDetailsActionTypes } from '@/admin/pages/studyGoRoomDetails/Constants';

import type { AdminRoomDetails } from '@/admin/pages/studyGoRoomDetails/types';

export interface GetRoomDetailsRequestAction {
	type: typeof roomDetailsActionTypes.GET_ROOM_DETAILS_REQUEST;
	payload: {
		episodeId: string;
		roomId: string;
	};
}

export interface GetRoomDetailsSuccessAction {
	type: typeof roomDetailsActionTypes.GET_ROOM_DETAILS_SUCCESS;
	payload: {
		room: AdminRoomDetails;
	};
}

export interface GetRoomDetailsErrorAction {
	type: typeof roomDetailsActionTypes.GET_ROOM_DETAILS_ERROR;
	payload: {
		error: string;
	};
}

export interface CleanRoomDetailsStateAction {
	type: typeof roomDetailsActionTypes.CLEAN_ROOM_DETAILS_STATE;
}

export type RoomDetailsActions =
	| GetRoomDetailsRequestAction
	| GetRoomDetailsSuccessAction
	| GetRoomDetailsErrorAction
	| CleanRoomDetailsStateAction;

export function getRoomDetailsRequest(
	episodeId: string,
	roomId: string,
): GetRoomDetailsRequestAction {
	return {
		type: roomDetailsActionTypes.GET_ROOM_DETAILS_REQUEST,
		payload: { episodeId, roomId },
	};
}

export function getRoomDetailsSuccess(data: {
	room: AdminRoomDetails;
}): GetRoomDetailsSuccessAction {
	return {
		type: roomDetailsActionTypes.GET_ROOM_DETAILS_SUCCESS,
		payload: data,
	};
}

export function getRoomDetailsError(error: string): GetRoomDetailsErrorAction {
	return {
		type: roomDetailsActionTypes.GET_ROOM_DETAILS_ERROR,
		payload: { error },
	};
}

export function cleanRoomDetailsState(): CleanRoomDetailsStateAction {
	return {
		type: roomDetailsActionTypes.CLEAN_ROOM_DETAILS_STATE,
	};
}
